import { Flex } from '@linearb/linui-common';
import { styled } from '@mui/material';

export const OrgInfoWrapper = styled(Flex)`
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-right: 1rem;
`;

export const SelectedOrgTitle = styled('span')`
  font-size: 1rem;
  font-weight: 300;
  margin-right: 0.5rem;
`;

export const OrgName = styled('span')`
  font-size: 1rem;
  font-weight: 300;
  font-family: Menlo, Monaco, 'Courier New', monospace !important;
`;
